import { initialState } from './ai-experience-context-plugin';
import type { AIExperienceContextAction, AIExperienceContextPluginState } from './types';

export function reducer({
	state,
	action,
}: {
	action: AIExperienceContextAction;
	state: AIExperienceContextPluginState;
}): AIExperienceContextPluginState {
	switch (action.type) {
		case 'RESET':
			return initialState;
		case 'STREAM':
			return {
				...state,
				adfResponse: action.adfResponse,
			};
		case 'COMPLETE':
			return {
				...state,
				adfResponse: action.adfResponse,
			};
		case 'ERROR':
			return {
				...state,
				errorInfo: action.errorInfo,
			};
		default:
			return state;
	}
}
